import { AnyAction } from "redux";
import {
  FETCH_CRITERIAS_ERROR,
  FETCH_CRITERIAS_SUCCESS,
  REQUEST_FETCH_CRITERIAS,
} from "redux/actions/products/criterias";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_CRITERIAS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CRITERIAS_SUCCESS:
      return {
        data: action.criterias,
        error: null,
        loading: false,
      };
    case FETCH_CRITERIAS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
